import { render, staticRenderFns } from "./EditableKeyValue.vue?vue&type=template&id=ff1bf478&"
import script from "./EditableKeyValue.vue?vue&type=script&lang=js&"
export * from "./EditableKeyValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports